// Copyright (c) Docugami, Inc. All rights reserved.

import styled from "styled-components"

export const IconWrapper = styled.div<{primaryColor?: string}>`
    text-align: center;
    font-weight: bold;
    margin: auto;
    color: ${props => props.primaryColor ?? 'white'};
    display: flex;
`

export const UserActionIconContainer = styled.div<{iconColor: string, size: string, iconSize: string, borderColor?: string}>`
    width: ${props => props.size};
    height: ${props => props.size};
    border-radius: ${props => props.size};
    background: ${props => props.iconColor};
    border: 1px solid ${props => props.borderColor ?? props.iconColor};
    display: flex;
    ${IconWrapper} {
        font-size: ${props => props.iconSize};
    }
`

export const OverflowTextContainer = styled.span<{maxLines: number}>`
    display: -webkit-box;
    -webkit-line-clamp: ${props => props.maxLines};
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
`